import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const p = window.location.pathname;
  const mobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  cfg.headers["X-Emission-Mode"] = p.startsWith("/pos") || p.startsWith("/sales-orders") ? (mobile ? "POS-MOVIL" : "POS") : (mobile ? "MOVIL" : "ERP");
  return cfg;
});

api.interceptors.response.use(
  (r) => {
    const w = r.headers?.["x-sequence-warning"];
    if (w) toast.warning(decodeURIComponent(w), { duration: 10000 });
    return r;
  },
  async (error) => {
    if (error?.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(error.config);
      } catch (e) {
        // not authenticated — let caller handle
      }
    }
    // 403 por módulo desactivado: marcar para que los callers lo ignoren
    // silenciosamente (ModuleRoute ya muestra la UI apropiada).
    if (error?.response?.status === 403) {
      const detail = error.response.data?.detail || "";
      if (typeof detail === "string" && detail.includes("módulo")) {
        error.isModuleDisabled = true;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Error desconocido";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" · ");
  return JSON.stringify(detail);
}

export default api;
